import {jwtDecode} from "jwt-decode";

export function getStudentIdFromToken() {
  const token = localStorage.getItem("token");
  if (!token) return null;
  const decoded = jwtDecode(token);
  return decoded.user_id;
}
